import { render, staticRenderFns } from "./mobilemenu.vue?vue&type=template&id=01367daa&scoped=true"
import script from "./mobilemenu.vue?vue&type=script&lang=js"
export * from "./mobilemenu.vue?vue&type=script&lang=js"
import style0 from "./mobilemenu.vue?vue&type=style&index=0&id=01367daa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01367daa",
  null
  
)

export default component.exports